import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import DashboardSidebar from '@/components/dashboardSidebar/dashboardSidebar.vue';
import DashboardSidebarMobile from '@/components/dashboardSidebarMobile/dashboardSidebarMobile.vue';


@Component({
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && !vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  },
  components: {
    DashboardSidebar,
    DashboardSidebarMobile
  }

})
export default class SubscriptionsOrders extends Vue {

 
  // Modal Test
  openModal = false;
  openEditModal = false;
  openFilterDropdown = false;
  openOrderDropdown = false;


  // For Pagination
  pageSize = 8;
  currentPage = 1;

  pedidos = [
      {
        id: 1,
        name: 'Martes, 15 Feb',
        label: 'Pedido actual',
        status: 'Confirmado',
        color: 'green',
        tab_status: true,
        description: 'Tu menú se encuentra <b>confirmado y en preparación</b>.'
      },
      {
        id: 2,
        name: 'Martes 22 Feb',
        label: 'Próximo Pedido',
        status: 'Abierto',
        color: 'yellow',
        tab_status: false,
        description: 'Puedes realizar <b>cambios a tu menú hasta el Domingo 15 Feb, a las 8:00 PM,</b>. luego se confirmará tu pedido automáticamentes'
      },
      {
        id: 3,
        name: 'Martes 28 Feb',
        label: 'Próximo Pedido',
        status: 'Saltado',
        color: 'red',
        tab_status: false,
        description: 'No recibirás un pedido esta semana, <b>puedes reactivarla hasta el 00 de Feb a las 10:00 AM </b>'
      },
      {
        id: 4,
        name: 'Martes 07 Mar',
        label: 'Próximo Pedido',
        status: 'Abierto',
        color: 'yellow',
        tab_status: false,
        description: 'Puedes realizar <b>cambios a tu menú hasta el Domingo 15 Feb, a las 8:00 PM,</b>. luego se confirmará tu pedido automáticamentes'
      }
  ]


  openCollapsible(id: any) {
    let content = document.getElementsByClassName('collapsible-content-'+id)[0]  as HTMLElement;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.marginTop = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.marginTop = 0.6 + 'rem'
    }


  }

  setActiveTab(id: any) {

    this.pedidos.forEach((pedido,index) => {
        pedido.tab_status = false;
    })

    this.pedidos[id].tab_status = true;
  }

  isActive(id: any) {
    return this.pedidos[id].tab_status ? 'active-'+this.pedidos[id].color : '';
  }
  
}
